import NorthRounded from '@mui/icons-material/NorthRounded';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppLink } from '@/components/atoms';
import { footerLinkSx } from '@/components/molecules';
import { type FooterContent } from '@/hooks/useFooterContent';
import { useScrollToTop } from '@/hooks/useScrollToTop';

/** Copyright, legal links and back-to-top. */
export function FooterLegalBar({ legal }: { legal: FooterContent['legal'] }) {
  const scrollToTop = useScrollToTop();
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      spacing={4}
      // `pr` keeps the right-hand links clear of the floating WhatsApp button.
      sx={{ pt: 6, pr: { md: 20 }, borderTop: 1, borderColor: 'divider' }}
    >
      <Typography variant="body2" color="text.secondary">
        {legal.copyright}
      </Typography>
      <Stack direction="row" alignItems="center" flexWrap="wrap" useFlexGap spacing={5}>
        {legal.links.map((link) => (
          <AppLink key={link.to} href={link.to} variant="body2" sx={footerLinkSx}>
            {link.label}
          </AppLink>
        ))}
        <Button
          size="small"
          color="inherit"
          endIcon={<NorthRounded />}
          onClick={scrollToTop}
          sx={{
            typography: 'body2',
            fontWeight: 600,
            color: 'text.secondary',
            '&:hover': { color: 'primary.main' },
          }}
        >
          Back to top
        </Button>
      </Stack>
    </Stack>
  );
}
